import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import HistoricalSearchResultsTable from './HistoricalSearchResultsTable'

export default function HistoricalSearchResultsDialog({
  persons,
  removePersonOnDelete,
  updatePersonOnEdit,
  countries,
  ...opener
}) {
  const { t } = useTranslation()
  const doneBtnOnClick = () => {
    opener.close()
  }

  return (
    <DialogOverlay
      {...opener}
      title={t('tools.lists.headings.resultsCount', 'Search Results')}
      subtitle={t('tools.lists.headings.personsFound_plural', '{count} persons found', {
        count: persons.length,
      })}
      size="xxl"
    >
      {persons.length > 0 && (
        <HistoricalSearchResultsTable
          persons={persons}
          removePersonOnDelete={removePersonOnDelete}
          updatePersonOnEdit={updatePersonOnEdit}
          countries={countries}
        />
      )}

      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="medium" onClick={doneBtnOnClick}>
            {persons.length > 0 ? t('action.done', 'Done') : t('action.ok', 'OK')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
